import React from 'react';
import PortfolioApp from './portfolio/App';

function App() {
  return <PortfolioApp />;
}

export default App;
